module.exports = __webpack_public_path__ + "static/img/_txbz.42309fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/_txbz.png
// module id = hY/6
// module chunks = 96